import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.url = this.getData('url')
        this.id = this.getData('id');
        
    }


    init() {
      this.call('destroy', this.el, 'app')
      
        fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          let self = this;
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('#product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.$(`content-${this.id}`)[0].innerHTML = recommendations.innerHTML;
          }
          // Added new product cards so update the scroll module to show lazy loaded images
 
          //Init the new product card modules within the scope of this module

          this.call('update', this.el, 'app')

          setTimeout(()=> {
            this.call('update', null, 'Scrollmodule');
          }, 200)
      
          //this.call('update', this.$(`content-${this.id}`)[0], 'app')
          
        })
        .catch((e) => {
          console.error(e);
        });

    }
}
